export function usePromoPopUpHelper() {
    function handlePromoPopUp(setShowPromoPopUp) {
        // const hasVisited = sessionStorage.getItem('hasVisited');

        if (window.showPromoPopup) {
            setTimeout(function () {
                setShowPromoPopUp(true);
            }, 2000);

            window.showPromoPopup = false;

            // sessionStorage.setItem('hasVisited', 'true');
        }
    }

    return  {
        handlePromoPopUp
    }
}